module.exports = "/_next/static/images/hove2@2x-36d914a5089c609d00369916ebf083a1.png";